import { KeyValuePair } from "../models/common/keyValuePair";

export const MONTHS: KeyValuePair[] =[
    {key: 0, value: 'January'},
    {key: 1, value: 'February'},
    {key: 2, value: 'March'},
    {key: 3, value: 'April'},
    {key: 4, value: 'May'},
    {key: 5, value: 'June'},
    {key: 6, value: 'July'},
    {key: 7, value: 'August'},
    {key: 8, value: 'September'},
    {key: 9, value: 'October'},
    {key: 10, value: 'November'},
    {key: 11, value: 'December'},
]


// WEBPACK FOOTER //
// ./src/app/contants/MONTHS.ts